module.exports = exports = require('./svm');
exports.kernel = require('./kernel').kernel;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-svm/src/index.js
 ** module id = 100
 ** module chunks = 0
 **/